import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, shallowRef } from 'vue'
import FileUpload from '@/components/UploadFile/index.vue'
import { UploadFileRes } from '@/api/common/common-api-type'
import * as DepAPI from '@/api/ocr'
import {
  Message as ElMessage,
} from 'element-ui'
import { OCR } from '@/api/ocr/type'
import { OCRSubAbilityType } from '@/api/common/common-api'
interface IForm {
  templateItem: OCR.PropertyItem,
  fileList: UploadFileRes[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OcrCard',
  emits: ['set-tab'],
  setup(__props, { emit: emits }) {

const options = ref<OCR.PropertyItem[]>([])
async function getProperty() {
  try {
    const { data } = await DepAPI.getOcrPropertyApi()
    options.value = data
  } catch (error) {
    error
  }
}
getProperty()

const subAbility = ref<OCRSubAbilityType>('BIZCARD')
// 切换识别模板时，修改上传传参
function changeSubAbility(item:OCR.PropertyItem) {
  if (item.type === OCR.PropertyType.BizCard) {
    subAbility.value = 'BIZCARD'
  } else {
    subAbility.value = 'TEMPLATE'
  }
}
const ruleForm = ref()
const form = ref<IForm>(resetForm())
function resetForm () {
  return {
    templateItem: options.value.length ? options.value[0] : {
      name: '名片',
      property: '',
      type: OCR.PropertyType.BizCard
    },
    fileList: []
  }
}
const validateProperty = (rule: any, value: string, callback: any) => {
  if (!value && value !== '') {
    callback(new Error('请选择识别模板'))
  } else {
    callback()
  }
}
const rules = reactive({
  templateItem: [
    { required: true, trigger: 'blur', validator: validateProperty}
  ],
  fileList: [
    { required: true, message: '请上传文件', trigger: 'blur' },
  ]
})
const fileUploadRef = shallowRef<InstanceType<typeof FileUpload>>()
// 存在正在上传的文件
const hasLoading = computed(() => fileUploadRef.value?.hasLoading)
// 存在上传失败的文件
const hasFailUpload = computed(() => fileUploadRef.value?.hasFailUpload)

//点击开始识别
const isLoading = ref(false)
async function startTask() {
  await ruleForm.value.validate()
  try {
    isLoading.value = true
    await DepAPI.createOCRTaskAPI(
      // 后端约定 property为 '' 时，languages为名片识别，其余情况为模板识别
      form.value.templateItem.type,
      form.value.fileList.map(t => t.id),
      form.value.templateItem.property
    )
    fileUploadRef.value?.clearFiles()
    ElMessage.success('创建成功')
    emits('set-tab', 'listOCR')
  } catch (error) {
    ElMessage.error('创建失败')
  } finally {
    isLoading.value = false
  }
}

return { __sfc: true,options, getProperty, subAbility, changeSubAbility, ruleForm, form, resetForm, validateProperty, rules, fileUploadRef, hasLoading, hasFailUpload, emits, isLoading, startTask, FileUpload }
}

})